import { render } from "./OrgaoArtImg.vue?vue&type=template&id=5e1c210e&scoped=true"
import script from "./OrgaoArtImg.vue?vue&type=script&lang=ts"
export * from "./OrgaoArtImg.vue?vue&type=script&lang=ts"

import "./OrgaoArtImg.vue?vue&type=style&index=0&id=5e1c210e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5e1c210e"

export default script